import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { RootState } from '../store/index';
import { apiService } from '../services/api';

export function useLegislationNotifications(enabled = true) {
  const { user } = useSelector((state: RootState) => state.auth);
  const queryClient = useQueryClient();

  const query = useQuery(
    ['in-app-notifications', user?.id],
    () => apiService.getInAppNotifications(),
    {
      enabled: enabled && !!user?.id,
      refetchInterval: 60_000,
      refetchOnWindowFocus: true,
    },
  );

  const markRead = async (notificationId: number) => {
    await apiService.markInAppNotificationRead(notificationId);
    await queryClient.invalidateQueries(['in-app-notifications', user?.id]);
  };

  const markAllRead = async () => {
    await apiService.markAllInAppNotificationsRead();
    await queryClient.invalidateQueries(['in-app-notifications', user?.id]);
  };

  return {
    notifications: query.data?.notifications ?? [],
    unreadCount: query.data?.unread_count ?? 0,
    total: query.data?.total ?? 0,
    isLoading: query.isLoading,
    markRead,
    markAllRead,
    refetch: query.refetch,
  };
}
